import React, { useState } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarState } from "src/store/global/snackbarState";
import { Box, Grid, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import EmailField from 'src/Patient/components/EmailField';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { valuesFormRegisterState } from 'src/Patient/state/atoms';
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom';
import ReCAPTCHA from 'react-google-recaptcha';

const FormSendEmailDelete = () => {
    const setSnackbar = useSetRecoilState(snackbarState);
    const { uswEmail } = useRecoilValue(valuesFormRegisterState);
    const { handleClickSendEmailDelete, loading } = useSavePatient()
    const [captchaToken, setCaptchaToken] = useState(null);

    const onChange = (value) => {
        setCaptchaToken(value)
    }

    const Validate = () => {
        if(uswEmail === null){
            setSnackbar({
                openAlert: true,
                severity: "error",
                text: "Ingrese su correo electronico",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });  
        }
        else if(captchaToken === null){
            setSnackbar({
                openAlert: true,
                severity: "error",
                text: "Resuelva el captcha para continuar",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });  
        }
        else{
            handleClickSendEmailDelete();
        }
    }

    return (
        <form className='formulario' action=''>
        <div className='animate__animated animate__fadeIn'>
            <Typography variant="subtitle1" color="primary">
                Escriba su correo electrónico
            </Typography>
            <Grid container spacing={2} mt={2}>
                <Grid item md={12} xs={12}>
                    <EmailField onKeyEnter={Validate}/>
                    <Typography variant="subtitle2" color={grey[400]} fontWeight={500} lineHeight={'15px'} fontSize={10} mt={1}>
                        Complete el siguiente captcha para continuar.
                    </Typography>
                </Grid>
            </Grid>

            <Box>
                    <ReCAPTCHA 
                        sitekey="6LeknW0pAAAAAIXqi4ouwkqje-xpmhkod1nPfmJ6"
                        onChange={onChange}
                    />
                </Box>

            <Grid container display={"flex"} justifyContent={"center"} p={2} mt={1}>

                <Box>
                    <ButtonCustom
                        color="secondary"
                        loading={loading}
                        text="Enviar"
                        icon={<NavigateNextIcon />}
                        onClick={Validate}
                    />
                </Box>

            </Grid>
        </div>
        </form>
    )
}

export default FormSendEmailDelete;